<template>
	<div class="container">
		<div class="content">
			<section>
				<div class="banner">
					<h1>
						
					</h1>
				</div>

				<br><br>

				<h2>
					 Ops! Stiamo implementando alcune novità 😉
				</h2>

				<h3>
					<b>Lo shop Quomi tornerà disponibile a breve!</b>
				</h3>
				<br>

				<p>
					Iscriviti alla newsletter e ti avviseremo non appena lo shop sarà di nuovo attivo.
					<br>
				</p>
			
 				<br>
				<div class="form flex-vcenter">
					<input
						type="email"
						class="form-control"
						v-model="email"
						placeholder="Inserisci la tua mail"
						autocomplete="email"
					>
					<CTA
						:content="`Iscriviti`"
						:size="`small`"
						@click="$_newsletter_newsletterList({ list: list, email: email })"
					/>
				</div>
				<div class="small-text">
					Iscrivendoti alla newsletter accetti le
					<router-link
						:to="{name: 'privacy-policy'}"
						:title='$t("components.checkbox.general_conditions")' target='_blank' class="link-detail"
					>
						condizioni relative alla privacy.
					</router-link>
				</div>
				<br>
				<div
					v-if="newsletterFlash"
					class="flash"
					:class="newsletterState"
				>
					{{ newsletterFlash }}
				</div>
			</section>

			<h2>Scopri le Gift Card Quomi</h2>

			<p class="text-center">Il regalo perfetto per ogni occasione.</p>
			<CTA
				class="ma-auto"
				:content="`Acquista le Gift Card Quomi`"
				:size="`small`"
				@click="$router.push({name: 'gift-card'})"
			/>
			<br><br>

			<h2>Ecco le ricette che potrai ordinare a breve</h2>

			<Slick>
				<div
					slot="slides"
					v-for="(item, index) in menu"
					:key="index"
					class="recipe"
				>
					<img
						:src="item.images.big"
						:alt='item.name'
					>
					<div class="recipe-name">
						{{ item.name }}
					</div>
				</div>
			</Slick>
		</div>
	</div>
</template>

<script type = "text/javascript" >
import { newsletter } from '../mixins/newsletter'

import Slick from './Slick'
import { goSlick } from '../assets/js/slick'
import { WeekPlanApi } from '../api/WeekPlanApi'
import CTA from './Elements/CTA'

export default {

	data () {
		return {
			menu: null,

			list: 'natale2019',

			email: ''
		}
	},

	mixins: [newsletter],

	components: {
		Slick,
		CTA
	},

	computed: {
		user () {
			return this.$root.user
		}
	},

	mounted () {
		this.email = this.user && !this.user.email.includes('guest.quomi.it') ? this.user.email : ''
		var wm = new WeekPlanApi()
		return wm.next()

		.then(response => {
			this.menu = response.body.data.resource.recipes
		}).then(response => {
			goSlick()
		})
	}
}

</script>

<style scoped>
h1 {
	font-weight: 300;
	font-size: 50px;
	color: white;
	text-shadow: 3px 3px 7px black;
	font-family: var(--quomi-cursive-font);
}

h2, h3 {
	text-align: center;
}

.content >>> .recipe {
	cursor: auto;
}

input {
	margin: 0;
	flex-grow: 1;
}

section {
	text-align: center;
}

.banner {
	background-size: cover;
	background-position: center center;
	position: relative;
	padding: 120px 20px;
	background-image: url('../assets/img/covers/mealkit.jpg');
}

.form {
	max-width: 500px;
	margin: 0 auto;
	justify-content: center;
}

.form button {
	height: 37px;
	padding: 5px 15px;
}

.flash {
	margin: 10px auto 0 auto;
}

.error {
	color: tomato;
}

.success {
	color: green;
}

@media (max-width: 1024px) {
}
</style>
